// Date du jour de l'entreprise : celle de Paris, jamais celle du serveur ni le temps universel.
// Entre minuit et 2 h (heure de Paris), le temps universel est encore la veille : une saisie datée en UTC
// et une autre datée par la base porteraient deux jours différents. Toute date « du jour » passe par ici.

export const FUSEAU_ENTREPRISE = 'Europe/Paris';
const FUSEAU = FUSEAU_ENTREPRISE;

/** Date du jour à Paris, au format AAAA-MM-JJ. */
export const dateDuJourParis = (maintenant: Date = new Date()): string =>
  new Intl.DateTimeFormat('fr-CA', { timeZone: FUSEAU, year: 'numeric', month: '2-digit', day: '2-digit' }).format(maintenant);

/** Date du jour à Paris, au format JJ/MM/AAAA (affichage, exports). */
export const dateDuJourParisFr = (maintenant: Date = new Date()): string =>
  new Intl.DateTimeFormat('fr-FR', { timeZone: FUSEAU, year: 'numeric', month: '2-digit', day: '2-digit' }).format(maintenant);

/**
 * Date calendaire RÉELLE au format AAAA-MM-JJ, vérifiée par aller-retour : « 2026-02-30 » ou « 2026-13-01 » sont refusées.
 * Seule fonction de validation des dates reçues par le module Contrats de maintenance (contrat, avenant, résiliation, visites).
 * Année bornée à 1900–2200 : « 0000-01-01 » passe en JavaScript mais Postgres la refuse (22008), ce qui ferait un 500.
 */
export const ANNEE_MIN_CALENDAIRE = 1900;
export const ANNEE_MAX_CALENDAIRE = 2200;
export function estDateCalendaire(s: unknown): s is string {
  if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
  const annee = Number(s.slice(0, 4));
  if (annee < ANNEE_MIN_CALENDAIRE || annee > ANNEE_MAX_CALENDAIRE) return false;
  const d = new Date(`${s}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s;
}
